/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum AlertType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  SuccessNextLine = 'success2',
  ErrorNextLine = 'error2',
  WarningNextLine = 'warning2',
  InfoNextLine = 'info2',
  WarningError = 'warningerror',
}
